export const SHOW_LOADER_MESSAGE = 'loader/SHOW_LOADER_MESSAGE';
export const HIDE_LOADER_MESSAGE = 'loader/HIDE_LOADER_MESSAGE';

const initialState = {
    showLoader: false,
    loaderMessage: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_LOADER_MESSAGE:
            return {
                ...state,
                showLoader: true,
                loaderMessage: action.message,
            };
        case HIDE_LOADER_MESSAGE:
            return {
                ...state,
                showLoader: false,
                loaderMessage: null
            };
        default:
            return state
    }
}

export const showLoaderMessage = (message) => {
    return dispatch => {
        dispatch({
            type: SHOW_LOADER_MESSAGE,
            message: message
        });
    }
};

export const hideLoaderMessage = () => {
    return dispatch => {
        dispatch({
            type: HIDE_LOADER_MESSAGE
        });
    }
};